import type { UserOwnershipOutput } from '@teo/backend';

/**
 * Returns a display name for an ownership entity based on its profile type
 * @param ownership The ownership entity
 * @returns A formatted display name (first + last name for individuals, business name for others)
 */
export const getOwnershipDisplayName = (ownership: UserOwnershipOutput) => {
  if (ownership.profile.ownershipProfileType === 'individual') {
    return `${ownership.profile.firstName} ${ownership.profile.lastName}`;
  } else {
    return ownership.profile.businessName;
  }
};

/**
 * Returns a formatted identification number (SSN or EIN) for an ownership entity
 * @param ownership The ownership entity
 * @returns A formatted identification string with appropriate label
 */
export const getIdentificationNumber = (ownership: UserOwnershipOutput) => {
  const label = ownership.profile.ownershipProfileType === 'individual' ? 'SSN' : 'EIN';
  return `${label}: ${ownership.maskedTaxId ?? 'Not provided'}`;
};
